import axios from 'axios';

import { setAlert } from './alert';
import { changeLoader } from './loader';
import { VENTAS } from './types';

export const buscarVentas = (filtros = {}) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ventas/listar`, body, config);
        await dispatch({ type: VENTAS.BUSCAR, payload: res.data.ventas });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const informacionVenta = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ventas/informacion`, body, config);
        await dispatch({ type: VENTAS.INFORMACION, payload: res.data.venta });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const limpiarVenta = () => dispatch => {
    dispatch({ type: VENTAS.LIMPIAR });
};
